import React from 'react';
import { useSupport } from '../../hooks/useSupport';
import {
  SupportContainer,
  LeftPanel,
  RightPanel,
  SupportCard,
  Title,
  InfoBox,
  FormGroup,
  Input,
  TextArea,
  SubmitButton,
  RequiredFooter
} from './Support.styles';
import bgImage from '../../assets/images/fondo_pantalla_ayuda.jpg';

export default function Support() {
  const { formData, loading, handleChange, handleSubmit } = useSupport();

  return (
    <SupportContainer>
      {/* Background Image Panel (Left) */}
      <LeftPanel $bgImage={bgImage} />

      {/* Form Panel (Right) */}
      <RightPanel>
        <SupportCard>
          <Title>Soporte Técnico ISA</Title>

          <InfoBox>
            Si tiene cualquier tipo de problema, solicitud o propuesta de mejora relacionada con la herramienta, puede contactarnos al <strong>+57 317 657 1502</strong>, a través del chat de WhatsApp{' '}
            <a href="https://chat.whatsapp.com/B6Yk0UUMavNGd9wTgT03ec?mode=gi_t" target="_blank" rel="noreferrer">
              Click Aquí.
            </a>{' '}
            o llenar el formulario. Nuestro equipo técnico se pondrá en contacto con usted a la mayor brevedad.
          </InfoBox>

          <form onSubmit={handleSubmit}>
            <FormGroup>
              <Input
                type="text"
                name="nombre"
                placeholder="Nombre completo*"
                value={formData.nombre}
                onChange={handleChange}
                required
              />
            </FormGroup>

            <FormGroup>
              <Input
                type="email"
                name="correo"
                placeholder="Correo electrónico*"
                value={formData.correo}
                onChange={handleChange}
                required
              />
            </FormGroup>

            <FormGroup>
              <Input
                type="tel"
                name="telefono"
                placeholder="Número de teléfono"
                value={formData.telefono}
                onChange={handleChange}
              />
            </FormGroup>

            <FormGroup>
              <TextArea
                name="mensaje"
                placeholder="Describa aquí su problema, solicitud o propuesta...*"
                value={formData.mensaje}
                onChange={handleChange}
                required
              />
            </FormGroup>

            <SubmitButton type="submit" disabled={loading}>
              {loading ? 'Enviando...' : 'Enviar Formulario'}
            </SubmitButton>
            <RequiredFooter>* Campos obligatorios</RequiredFooter>
          </form>
        </SupportCard>
      </RightPanel>
    </SupportContainer>
  );
}
